module.exports = __webpack_public_path__ + "img/section4Logo2.e41c0300.png";